"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepDateAndTime = void 0;
const addYears_1 = __importDefault(require("date-fns/addYears"));
const query_string_1 = require("query-string");
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const configContext_1 = require("../../context/configContext");
const environment_1 = require("../../environment");
const dateUtils = __importStar(require("../../utils/dateUtils"));
const ScrollToTopController_1 = require("../../utils/ScrollToTopController");
const SingleEventCalendar_1 = require("../calendar/SingleEventCalendar");
const ResourceIconWithColor_1 = require("../resource-icon-with-color/ResourceIconWithColor");
require("./StepDateAndTime.scss");
const StepDateAndTime = (props) => {
    const [showErrors, setShowErrors] = (0, react_1.useState)(false);
    const [isValid, setIsValid] = (0, react_1.useState)(false);
    const [busyEvents, setBusyEvents] = (0, react_1.useState)([]);
    const [isBusyEventsLoading, setIsBusyEventsLoading] = (0, react_1.useState)(false);
    const [visibleDates, setVisibleDates] = (0, react_1.useState)();
    const config = (0, configContext_1.useConfig)();
    /**
     * Load the busy events for the currently visible dates.
     */
    (0, react_1.useEffect)(() => {
        const abortController = new AbortController();
        async function fetchBusyEvents(from, to) {
            setIsBusyEventsLoading(true);
            try {
                const queryStr = (0, query_string_1.stringify)({
                    from: from.toISOString(),
                    to: to.toISOString(),
                });
                const response = await fetch(`${(0, environment_1.getEnv)().baseUrl}/api/tenants/${config.tenantId}/resources/${props.booking.configResource.id}/busy?${queryStr}`, { signal: abortController.signal });
                const responseJson = await response.json();
                const busyEvents = responseJson.map((event) => ({
                    start: dateUtils.convertToDate(event.start),
                    end: dateUtils.convertToDate(event.end),
                    classNames: ["busy"],
                    rendering: "background",
                }));
                setBusyEvents(busyEvents);
                setIsBusyEventsLoading(false);
            }
            catch (error) {
                if (!abortController.signal.aborted) {
                    throw error;
                }
            }
        }
        if (visibleDates !== undefined) {
            fetchBusyEvents(visibleDates.from, visibleDates.to);
            return () => abortController.abort();
        }
        return undefined;
    }, [visibleDates, props.booking.configResource]);
    /**
     * Handle the next button click.
     */
    function handleNext() {
        if (!showErrors) {
            // User clicked button for the first time. Show validation on next render.
            setShowErrors(true);
        }
        if (isValid) {
            props.onNext();
        }
    }
    return (react_1.default.createElement("div", { className: "step-date-and-time" },
        react_1.default.createElement(ScrollToTopController_1.ScrollToTop, null),
        react_1.default.createElement("h3", null, "Zeitraum"),
        react_1.default.createElement(SingleEventCalendar_1.SingleEventCalendar, { configResource: props.booking.configResource, bookingEvent: props.booking, onBookingEventChange: (event) => {
                props.onBookingChange({ start: event.start, end: event.end });
            }, busyEvents: busyEvents, isBusyEventsLoading: isBusyEventsLoading, visibleDates: visibleDates, onVisibleDatesChange: setVisibleDates, minDate: new Date(), maxDate: (0, addYears_1.default)(new Date(), 1), isValid: isValid, isValidChange: setIsValid, showErrors: showErrors }),
        react_1.default.createElement(Row_1.default, { className: "mt-3" },
            config.getVisibleResources().length > 1 && (react_1.default.createElement(Col_1.default, null,
                react_1.default.createElement(Dropdown_1.default, { drop: "up", className: "other-resources-dropdown" },
                    react_1.default.createElement(Dropdown_1.default.Toggle, { variant: "outline-secondary", size: "lg", id: "other-resource" }, "Andere R\u00E4ume"),
                    react_1.default.createElement(Dropdown_1.default.Menu, null,
                        react_1.default.createElement(Dropdown_1.default.Item, { href: `/resources/${config.tenantId}/` },
                            react_1.default.createElement("strong", null, "\u00DCbersicht anzeigen")),
                        react_1.default.createElement(Dropdown_1.default.Divider, null),
                        config.getVisibleResources().map((resource) => {
                            if (resource.id !== props.booking.configResource.id) {
                                return (react_1.default.createElement(Dropdown_1.default.Item, { key: resource.id, onClick: () => {
                                        props.onResourceChange(resource.id);
                                    } },
                                    react_1.default.createElement(ResourceIconWithColor_1.ResourceIconWithColor, { resource: resource })));
                            }
                            return undefined;
                        }))))),
            react_1.default.createElement(Col_1.default, { className: "text-right" },
                react_1.default.createElement(Button_1.default, { className: "text-nowrap", variant: "primary", size: "lg", onClick: handleNext, disabled: isBusyEventsLoading || (showErrors && !isValid) }, "Weiter")))));
};
exports.StepDateAndTime = StepDateAndTime;
